import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUser, clearUser, rehydrateUser } from '../../store/userSlice';

import axios from 'axios';
import config from '../../config';

const useAuthenticate = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user); // get user from Redux
    const [isLoading, setIsLoading] = useState(true);

    // Load user from localStorage - check if this is okay
    useEffect(() => {
        dispatch(rehydrateUser());
    }, [dispatch]);

    // Verify with backend
    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await axios.get(`${config.API_URL}/v2/auth/authenticate`, { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } });

                if (response.status === 200) {
                    dispatch(setUser(response.data)); // update Redux + storage
                } else {
                    dispatch(clearUser());
                }
            } catch (error) {
                console.error('Authentication error:', error);
                dispatch(clearUser());
            } finally {
                setIsLoading(false);
            }
        };

        checkAuth();
    }, [dispatch, user?.id]);

    return { isAuthenticated: !!user?.id, isLoading, user };
};

export default useAuthenticate;
